export enum MailSortOption {
  DateNewest = 0,
  DateOldest = 1,
  SenderAZ = 2,
  SenderZA = 3,
  SubjectAZ = 4,
  SubjectZA = 5
}

